import React from 'react'

import {
  PersonFill,
} from 'react-bootstrap-icons'

interface Props {
  req: any
}

export default function RequestItem({req}: Props) {
  return (
    <div className="rounded bg-white overflow-hidden border border-gray">
      <div className="d-flex align-items-center p-4 border-bottom border-light">
        <PersonFill size={15} className="mr-2 mb-1" />
        <h6 className="mb-0"><strong>{req?.user?.name}</strong></h6>
      </div>
      <div className="d-flex flex-column px-4 py-3">
        <div>
          <p className="text-muted mb-0"><small>Fyrirtæki:<strong className="pl-2">{req?.company_name}</strong></small></p>
        </div>
        <div>
          <p className="text-muted mb-0"><small>Kennitala:<strong className="pl-2">{req?.company_ssn}</strong></small></p>
        </div>
        <div>
          <p className="text-muted mb-0"><small>Skilaboð:<strong className="pl-2">{req?.message || '-'}</strong></small></p>
        </div>
      </div>
    </div>
  )
}
